import { Container } from '@mui/material';
import React from 'react';

const Payment = () => {
    return (
        <div>
            
            <Container> <h2>Payment system coming soon.</h2></Container>
           
        </div>
    );
};

export default Payment;